<template>
  <div class="content">
    <img class="image" :src="cover" alt="" />
    <img class="play-btn" src="../../../static/images/play-btn.png" alt="" />
  </div>
</template>

<script>
export default {
  name: 'previewPic', // 封面图

  props: {
    image: {
      type: String,
      require: true
    }
  },

  data() {
    return {}
  },

  computed: {
    cover() {
      return this.image || ''
    }
  },

  mounted() {},

  methods: {}
}
</script>

<style lang="less" scoped>
.content {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  // filter: brightness(50%);
  opacity: 0.5;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -50%;
}
.play-btn {
  position: absolute;
  left: 10px;
  bottom: 10px;
  width: 60px;
  height: 60px;
}
</style>
